import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { ConnectedProps } from 'react-redux';
import { rootReducer, State } from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;

export type AppConnectedProps<TConnector> = ConnectedProps<TConnector> & {
  dispatch: AppDispatch;
};

export type AppThunk = ThunkAction<void, State, unknown, Action<string>>;
